// @material-ui/icons
import Dashboard from "@material-ui/icons/Dashboard";
import Person from "@material-ui/icons/Person";
import Assignment from "@material-ui/icons/Assignment";
// import ContentPaste from "@material-ui/icons/ContentPaste";
import LibraryBooks from "@material-ui/icons/LibraryBooks";
import BubbleChart from "@material-ui/icons/BubbleChart";
import LocationOn from "@material-ui/icons/LocationOn";
import Notifications from "@material-ui/icons/Notifications";
import Unarchive from "@material-ui/icons/Unarchive";
// core components/views
import DashboardPage from "views/Dashboard/Dashboard.jsx";
import DashboardPage2 from "views/Dashboard/Dashboard2.jsx";
import QuoteService from "views/QuoteService/QuoteService.jsx";
import RateCard from "views/RateCard/RateCard.jsx";
import Login from "views/Login/Login.jsx";

import UserProfile from "views/UserProfile/UserProfile.jsx";
import TableList from "views/TableList/TableList.jsx";
import Typography from "views/Typography/Typography.jsx";
import Icons from "views/Icons/Icons.jsx";
import Maps from "views/Maps/Maps.jsx";
import NotificationsPage from "views/Notifications/Notifications.jsx";
import UpgradeToPro from "views/UpgradeToPro/UpgradeToPro.jsx";

const dashboardRoutes = [
  {
    path: "/dashboard",
    sidebarName: "Services",
    navbarName: "Services",
    icon: Dashboard,
    component: DashboardPage
  },
  {
    path: "/quote_service",
    sidebarName: "Quote Service",
    navbarName: "Quote Service",
    icon: Assignment,
    component: QuoteService
  },
  {
    path: "/rate_card/:rateCardId",
    sidebarName: false,
    navbarName: false,
    icon: Assignment,
    component: RateCard
  },
  {
    path: "/login",
    sidebarName: false,
    navbarName: false,
    icon: Assignment,
    component: Login,
    isPublicRoute:true
  },
  { redirect: true, path: "/", to: "/dashboard", navbarName: "Redirect" }
];

export default dashboardRoutes;



// WEBPACK FOOTER //
// ./src/routes/dashboard.jsx